import React, { useRef, useEffect } from "react"
import { useForm } from "react-hook-form"
import { chakra, Input, Flex, Box, Tooltip } from "@chakra-ui/react"
import { formParamsUpdate } from "../../redux/actions/project"
import { LabelTop } from "../../componentsWithChakra"

import {
  PARAMS_BORDERS_MESSAGE,
  PARAMS_BORDERS_REGEX,
} from "../../const/messages"

import objDeepTrim from "../../functions/utils/objDeepTrim"

const FormParams = ({ project, settings, isResetForm = false, dispatch }) => {
  //=================================================================
  const { currencySymbol } = settings

  const inputRef = useRef(null)

  const { register, handleSubmit, reset, errors } = useForm()

  const {
    pUnresolvedIssues,
    pDOCThroughDOXS,
    pDOCThroughDOTS,
    pSatisfactionCustomer,
    pSatisfactionTeam,
  } = project.params

  //-----------------------------------------------------------------
  useEffect(() => {
    if (isResetForm) {
      reset()
    }
  }, [isResetForm, reset])

  //-----------------------------------------------------------------
  const onSubmit = (data) => {
    inputRef.current.focus()
    objDeepTrim(data)
    const payload = { data }
    dispatch(formParamsUpdate(payload))
  }

  //=================================================================
  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Flex>
        <Flex w="50%" justify="flex-end"></Flex>
        <Flex w="50%" justify="flex-end" wrap="wrap">
          <Box w={["50%", "50%"]} pl={[0, 0, 0, 0]} pr={[1, 1, 1, 1]}>
            <LabelTop>Currency Symbol</LabelTop>
            <Input
              name="currencySymbol"
              defaultValue={currencySymbol}
              ref={register}
            />
          </Box>
          <Box w={["50%", "50%"]} pl={[1, 1, 1, 1]} pr={[0, 0, 0, 0]}>
            <Tooltip label="Number of Unresolved Pieces (Π)">
              <LabelTop>Unresolved Issues Π</LabelTop>
            </Tooltip>
            <Tooltip
              isOpen={errors.pUnresolvedIssues}
              label={
                errors.pUnresolvedIssues ? errors.pUnresolvedIssues.message : ""
              }
              placement="top"
              hasArrow
              bg="red.500"
            >
              <Input
                name="pUnresolvedIssues"
                defaultValue={pUnresolvedIssues
                  .map((el) => el.toString())
                  .join(", ")}
                ref={register({
                  required: "Invalid: Please enter the traffic light borders.",
                  pattern: {
                    value: PARAMS_BORDERS_REGEX,
                    message: PARAMS_BORDERS_MESSAGE,
                  },
                })}
              />
            </Tooltip>
          </Box>

          <Box w={["50%", "50%"]} pl={[0, 0, 0, 0]} pr={[1, 1, 1, 1]}>
            <LabelTop>DOC / DOXS %-Borders</LabelTop>
            <Tooltip
              isOpen={errors.pDOCThroughDOXS}
              label={
                errors.pDOCThroughDOXS ? errors.pDOCThroughDOXS.message : ""
              }
              placement="top"
              hasArrow
              bg="red.500"
            >
              <Input
                name="pDOCThroughDOXS"
                ref={register({
                  required: "Invalid: Please enter the DOC/DOXS borders.",
                  pattern: {
                    value: PARAMS_BORDERS_REGEX,
                    message: PARAMS_BORDERS_MESSAGE,
                  },
                })}
                defaultValue={pDOCThroughDOXS
                  .map((el) => el.toString())
                  .join(", ")}
              />
            </Tooltip>
          </Box>
          <Box w={["50%", "50%"]} pl={[1, 1, 1, 1]} pr={[0, 0, 0, 0]}>
            <LabelTop>DOC / DOTS %-Borders</LabelTop>
            <Tooltip
              isOpen={errors.pDOCThroughDOTS}
              label={
                errors.pDOCThroughDOTS ? errors.pDOCThroughDOTS.message : ""
              }
              placement="top"
              hasArrow
              bg="red.500"
            >
              <Input
                name="pDOCThroughDOTS"
                ref={register({
                  required: "Invalid: Please enter the DOC/DOTS borders.",
                  pattern: {
                    value: PARAMS_BORDERS_REGEX,
                    message: PARAMS_BORDERS_MESSAGE,
                  },
                })}
                defaultValue={pDOCThroughDOTS
                  .map((el) => el.toString())
                  .join(", ")}
              />
            </Tooltip>
          </Box>
          <Box w={["50%", "50%"]} pl={[0, 0, 0, 0]} pr={[1, 1, 1, 1]}>
            <LabelTop>Team Satisfaction %-Borders</LabelTop>
            <Tooltip
              isOpen={errors.pSatisfactionTeam}
              label={
                errors.pSatisfactionTeam ? errors.pSatisfactionTeam.message : ""
              }
              placement="top"
              hasArrow
              bg="red.500"
            >
              <Input
                name="pSatisfactionTeam"
                ref={register({
                  required: "Invalid: Please enter the traffic light borders.",
                  pattern: {
                    value: PARAMS_BORDERS_REGEX,
                    message: PARAMS_BORDERS_MESSAGE,
                  },
                })}
                defaultValue={pSatisfactionTeam
                  .map((el) => el.toString())
                  .join(", ")}
              />
            </Tooltip>
          </Box>
          <Box w={["50%", "50%"]} pl={[0, 0, 1, 1]} pr={[1, 1, 1, 1]}>
            <LabelTop>Team Customer %-Borders</LabelTop>
            <Tooltip
              isOpen={errors.pSatisfactionCustomer}
              label={
                errors.pSatisfactionCustomer
                  ? errors.pSatisfactionCustomer.message
                  : ""
              }
              placement="top"
              hasArrow
              bg="red.500"
            >
              <Input
                name="pSatisfactionCustomer"
                ref={register({
                  required: "Invalid: Please enter the traffic light borders.",
                  pattern: {
                    value: PARAMS_BORDERS_REGEX,
                    message: PARAMS_BORDERS_MESSAGE,
                  },
                })}
                defaultValue={pSatisfactionCustomer
                  .map((el) => el.toString())
                  .join(", ")}
              />
            </Tooltip>
          </Box>
          <Box w="100%" order={[10]} mb={4}>
            <chakra.button type="submit" ref={inputRef} outline="none">
              OK
            </chakra.button>
          </Box>
        </Flex>
      </Flex>
    </form>
  )
}

export default FormParams
